module.exports = "/_next/static/images/onboard-payroll-1-ea708fa1d7d02ad81ce344a12ca82006.svg";